import { useContext, useEffect } from 'react';
import { useGetAppViewerQuery } from './gql/getAppViewer.generated';
import { Viewer } from '@Global/apollo/types';
import { ViewerContext } from '@Global/store';

/** хук запроса возвращающий стартовые флаги  */
export const useAppViewer = () => {
  const viewerCtx = useContext(ViewerContext);
  const { loading, data, refetch } = useGetAppViewerQuery({
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    if (!loading && data) {
      viewerCtx.updateViewer(data.viewer as Viewer, data.viewer.id);
    }
  }, [loading, data]);

  return {
    loading,
    data,
    refetch,
    subscription: data?.viewer?.subscription,
  };
};
